export const TIMELINE_KINDS = [
    { kind: 'construction', icon: 'bi-hammer', color: '#6c757d', label: 'Construction' },
    { kind: 'renovation', icon: 'bi-tools', color: '#0d6efd', label: 'Renovation' },
    { kind: 'addition', icon: 'bi-plus-circle', color: '#198754', label: 'Addition' },
    { kind: 'damage', icon: 'bi-exclamation-triangle', color: '#dc3545', label: 'Damage' },
    { kind: 'restoration', icon: 'bi-arrow-counterclockwise', color: '#6f42c1', label: 'Restoration' },
    { kind: 'event', icon: 'bi-calendar-event', color: '#fd7e14', label: 'Event' },
    { kind: 'ownership', icon: 'bi-person-fill', color: '#20c997', label: 'Ownership' },
    { kind: 'other', icon: 'bi-three-dots', color: '#6c757d', label: 'Other' },
];
export const getTimelineKind = (kind) => { var _a; return (_a = TIMELINE_KINDS.find((c) => c.kind === kind)) !== null && _a !== void 0 ? _a : TIMELINE_KINDS[TIMELINE_KINDS.length - 1]; };
export const OWNER_CONTROLLED_TYPES = ['damage', 'ownership'];
export const DISPLAY_FORMATS = [
    { format: 'exact', label: 'Exact' },
    { format: 'month', label: 'Month' },
    { format: 'year', label: 'Year' },
    { format: 'decade', label: 'Decade' },
    { format: 'range', label: 'Range' },
    { format: 'other', label: 'Other' },
];
export const RANGE_END_DEFAULT = 'Present';
const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const MONTHS_LONG = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const formatTimelineDate = (format, date, rangeEnd, otherText) => {
    const y = date.year();
    const m = date.monthValue();
    const d = date.dayOfMonth();
    return format === 'exact' ? `${MONTHS_SHORT[m - 1]} ${d}, ${y}`
        : format === 'month' ? `${MONTHS_LONG[m - 1]} ${y}`
            : format === 'year' ? `${y}`
                : format === 'decade' ? `${Math.floor(y / 10) * 10}s`
                    : format === 'range' ? `${y}–${rangeEnd}`
                        : otherText;
};
